import React from 'react'
import { cn } from '@/lib/utils'

export interface SpinnerProps {
  /** Spinner size */
  size?: 'small' | 'medium' | 'large'
  /** Color */
  color?: 'primary' | 'white' | 'subdued'
  /** Accessibility label */
  accessibilityLabel?: string
  /** Additional class name */
  className?: string
  /** Data ID for testing */
  'data-id'?: string
}

export const Spinner: React.FC<SpinnerProps> = ({
  size = 'medium',
  color = 'primary',
  accessibilityLabel = 'Carregando',
  className,
  'data-id': dataId,
}) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-5 h-5',
    large: 'w-8 h-8',
  }

  const colorClasses = {
    primary: 'text-foreground',
    white: 'text-white',
    subdued: 'text-muted-foreground',
  }

  return (
    <span
      role="status"
      aria-label={accessibilityLabel}
      className={cn('inline-block', className)}
      data-id={dataId}
    >
      <svg
        className={cn(
          'animate-spin',
          sizeClasses[size],
          colorClasses[color]
        )}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      <span className="sr-only">{accessibilityLabel}</span>
    </span>
  )
}
